import { useCallback, useEffect, useState } from 'react';
import MKBox from 'components/MaterialKit/MKBox';
import { handleErrorResponse } from 'utils/general';
import { useAuth } from 'contexts/auth';
import MKTypography from 'components/MaterialKit/MKTypography';
import DataTable from 'components/DataTable';
import { useNavigate, useParams } from 'react-router-dom';
import { getLayouts } from 'api/pages';
import { withLoading } from 'utils/hoc';
import { deleteLayout } from 'api/layouts';

const layoutTableColumn = [
  {
    field: 'layout_id',
    label: 'Layout ID',
    sortable: true,
  },
  {
    field: 'name',
    label: 'Name',
    sortable: true,
  },
  {
    field: 'menu.display_name',
    label: 'Menu Display Name',
  },
  {
    field: 'header.section_definition.collection_definition.name',
    label: 'Header Name',
  },
  {
    field: 'footer.section_definition.collection_definition.name',
    label: 'Footer Name',
  },
];

const LayoutSection = ({ setLoading }) => {
  const { setAuth } = useAuth();
  const [layouts, setLayouts] = useState([]);
  const navigate = useNavigate();
  const { appId } = useParams();

  const fetchLayoutsFromApi = useCallback(() => {
    const layoutParams = {
      $expand: 'menu,header/section_definition/collection_definition,footer/section_definition/collection_definition',
    };
    return getLayouts(layoutParams)
      .then(({ data }) => {
        setLayouts(data);
      })
      .catch((err) => {
        handleErrorResponse(err, setAuth);
      });
  }, [setAuth]);

  useEffect(() => {
    fetchLayoutsFromApi();
  }, [fetchLayoutsFromApi]);

  const onPressEdit = useCallback((layoutId) => {
    navigate(`/app/${appId}/layout/${layoutId}`);
  }, [appId, navigate]);

  const onPressAdd = useCallback(() => {
    navigate(`/app/${appId}/layout`);
  }, [appId, navigate]);

  const onPressDelete = useCallback((layoutId) => {
    setLoading(true);
    return deleteLayout(layoutId)
      .then(() => {
        return fetchLayoutsFromApi();
      })
      .catch((err) => {
        handleErrorResponse(err, setAuth);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [fetchLayoutsFromApi, setLoading, setAuth]);

  return (
    <MKBox mt={3}>
      <MKBox display="flex" justifyContent="space-between" alignItems="center" p={1}>
        <MKTypography variant="h6">Layout</MKTypography>
      </MKBox>
      <DataTable
        data={layouts}
        columns={layoutTableColumn}
        idField="layout_id"
        onPressEdit={onPressEdit}
        onPressAdd={onPressAdd}
        paginationDisabled
        selectable
      />
    </MKBox>
  );
};

LayoutSection.propTypes = {
  setLoading: LayoutSection.func,
};

export default withLoading(LayoutSection);
